import React, { useState, useCallback, useMemo } from "react";

const EducationModal = React.memo(({ initialEducation, onEducationUpdate }) => {
  const [inputValue, setInputValue] = useState("");

  const normalizedEducation = useMemo(
    () =>
      Array.isArray(initialEducation)
        ? initialEducation.map((item) =>
            typeof item === "object" ? item.name : item
          )
        : [],
    [initialEducation]
  );

  const [educationList, setEducationList] = useState(normalizedEducation);

  const handleInputChange = useCallback((e) => {
    setInputValue(e.target.value);
  }, []);

  const addEducation = useCallback(() => {
    if (inputValue.trim() !== "") {
      const updatedList = [...educationList, inputValue.trim()];
      setEducationList(updatedList);
      setInputValue("");
      if (onEducationUpdate) onEducationUpdate(updatedList);
    }
  }, [inputValue, educationList, onEducationUpdate]);

  const removeEducation = useCallback(
    (index) => {
      const updatedList = educationList.filter((_, i) => i !== index);
      setEducationList(updatedList);
      if (onEducationUpdate) onEducationUpdate(updatedList);
    },
    [educationList, onEducationUpdate]
  );

  return (
    <div>
      <div className="form-group w-full">
        <label htmlFor="education" className="label-edit">
          Eğitim ve Sertifikalar
        </label>
        <div className="relative">
          <input
            type="text"
            className="custom-input w-full px-4"
            placeholder="Eğitim / Sertifika Ekleyiniz.."
            value={inputValue}
            onChange={handleInputChange}
          />
          <button
            type="button"
            onClick={addEducation}
            className=" absolute right-3 top-1/2 transform -translate-y-1/2"
          >
            +
          </button>
        </div>
      </div>
      <ul className="mt-4">
        {educationList.length > 0 ? (
          educationList.map((item, index) => (
            <li
              key={index}
              className="flex justify-between items-center gap-2 m-3"
            >
              <span className="text-grayy break-words flex-1">• {item}</span>
              <button
                type="button"
                onClick={() => removeEducation(index)}
                className="text-errorRed flex-shrink-0 ml-2"
              >
                −
              </button>
            </li>
          ))
        ) : (
          <p className="empty-message">Henüz eklenmiş eğitim yok.</p>
        )}
      </ul>
      <input
        type="hidden"
        name="edu_cert"
        value={JSON.stringify(educationList)}
      />
    </div>
  );
});

export default EducationModal;
